"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonProps = void 0;

var getButtonProps = function getButtonProps(isButton) {
  return isButton ? {
    role: 'button',
    tabIndex: 0
  } : {};
};

exports.getButtonProps = getButtonProps;